// Libraries
import { useUserStore } from '@/lib/store/user'


// Views
const ViewMain = () => import(/* webpackChunkName: "main" */ '@/views/Main.vue')
const ViewPublic = () => import(/* webpackChunkName: "public" */ '@/views/Public.vue')

// Partials
const PartialAuthSelect = () => import(/* webpackChunkName: "login" */ '@/views/partials/AuthSelect.vue')
const PartialAuthVerify = () => import(/* webpackChunkName: "login" */ '@/views/partials/AuthVerify.vue')
const PartialCustomers = () => import(/* webpackChunkName: "organization" */ '@/views/partials/Customers.vue')
const PartialCustomer = () => import(/* webpackChunkName: "organization" */ '@/views/partials/Customer.vue')

const PartialGuideline = () => import(/* webpackChunkName: "main" */ '@/views/partials/Guideline.vue')
const PartialAdjustment = () => import(/* webpackChunkName: "main" */ '@/views/partials/Adjustment.vue')
const PartialStatute = () => import(/* webpackChunkName: "main" */ '@/views/partials/Statute.vue')
const PartialLogin = () => import(/* webpackChunkName: "login" */ '@/views/partials/Login.vue')
const PartialUsers = () => import(/* webpackChunkName: "user" */ '@/views/partials/Users.vue')
const PartialUser = () => import(/* webpackChunkName: "user" */ '@/views/partials/User.vue')

const userGuard = async (to, from, next) => {
	const userStore = useUserStore()
	let user

	try {
		user = await userStore.checkUser()
	} catch (error) {
		return next({ name: 'login' })
	}
	console.log('[userGuard]', { user, }, userStore.claims)
	if (!user) {
		return next({ name: 'login' })
	}

	if (!userStore.claims?.metadata?.mfaVerified) {
		console.log('[userGuard]', 'goVerify')
		return next({ name: 'authVerify' })
	}
	if (!userStore.claims?.tenantId) {
		console.log('[userGuard]', 'goSelect')
		return next({ name: 'select'})
	}

	return next()
}

const authGuard = async (to, from, next) => {
	const userStore = useUserStore()
	let user

	if (to.name == 'login') return next()
console.log('[authGuard]', { to, from, })
	try {
		user = await userStore.checkUser()
	} catch (error) {
		return next({ name: 'login' })
	}
	console.log('[authGuard]', { user, }, userStore.claims)
	if (!user) {
		return next({ name: 'login' })
	}

	return next()
}

export const routes = [
	{
		name: 'public',
		path: '/auth/',
		component: ViewPublic,
		beforeEnter: authGuard,
		children: [
			{
				name: 'login',
				path: 'login',
				components: {
					Content: PartialLogin,
				},
			},
			{
				name: 'authVerify',
				path: 'verify',
				components: {
					Content: PartialAuthVerify,
				},
			},
			{
				name: 'authSelect',
				path: 'select',
				components: {
					Content: PartialAuthSelect,
				},
			},
		],
	},
	{
		name: 'main',
		path: '/',
		component: ViewMain,
		beforeEnter: userGuard,
		children: [
			{
				name: 'customers',
				path: '',
				components: {
					Content: PartialCustomers,
				},

			},
			{
				name: 'customer',
				path: 'customer/:customerId?',
				components: {
					Content: PartialCustomers,
					Modal: PartialCustomer,
				},
				meta: {
					modalVisible: true,
					modalTitle: `Manage Customer`,
				},
			},
			{
				name: 'users',
				path: 'users',
				components: {
					Content: PartialUsers,
				},
			},
			{
				name: 'guideline',
				path: 'guideline/:guidelineId?/:version?',
				components: {
					Content: PartialGuideline,
				}
			},
			{
				name: 'adjustment',
				path: 'adjustment/:adjustmentId?/:version?',
				components: {
					Content: PartialAdjustment,
				}
			},
			{
				name: 'statute',
				path: 'statute/:statuteId?',
				components: {
					Content: PartialStatute,
				},
			},

			{
				name: 'user',
				path: 'user/:userId?',
				components: {
					Content: PartialUsers,
					Modal: PartialUser,
				},
				meta: {
					modalVisible: true,
					modalTitle: `Manage User`
				},
			},

		]
	}
]
